import types from './types'
import axios from 'axios'
import get from 'lodash/get'

export default {
  namespaced: true,
  state: {
    status: void 0,
    questionnaire: {},
    items: [],
    total: 0
  },
  actions: {
    async getList ({ commit }, { questionnaireId, page = 1, perPage = 10, sf, so, lang, months }){
      commit(types.GET_TEAMS.REQUEST, { questionnaireId, page, perPage, sf, so })
      try {
        commit(types.GET_TEAMS.SUCCESS, await axios.get(`/api/myTeam/questionnaires/${questionnaireId}`, { params: { l: perPage, lo: page - 1, sf, so, lang, months } }))
      } catch (err) {
        commit(types.GET_TEAMS.FAILURE)
      } finally {
      }
    }
  },
  mutations: {
    [types.GET_TEAMS.REQUEST] (state, params) {
      state.status = 'fetching'
      if ( get(state.questionnaire, '_id') !== params.questionnaireId){
        state.items = []
      }
    },
    [types.GET_TEAMS.SUCCESS] (state, result) {
      state.status = 'success'
      state.items = result.data.items
      state.total = result.data.total
      state.questionnaire = result.data.questionnaire
    },
    [types.GET_TEAMS.FAILURE] (state) {
      state.status = 'error'
    }
  },
  getters: {
    getTeams: state => questionnaireId => {
      if ( get(state.questionnaire, '_id') === questionnaireId ){
        return state.items
      }
      return null
    }
  }
}
